import 'regenerator-runtime/runtime';

export function loadMore() {

  async function getMorePosts(dataset) {

    let loadMoreButton = document.getElementById('loadMorePosts');

    const formdata = new FormData();
    formdata.append("action", "load_more_posts");
    formdata.append("paged", dataset.paged);
    formdata.append("max_num_pages", dataset.max_num_pages);
    formdata.append("posts_per_page", dataset.posts_per_page);
    formdata.append("post__not_in", dataset.post__not_in);
    formdata.append("term_type", dataset.term_type);
    formdata.append("terms", dataset.terms);

    const requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow"
    };
    
    fetch(theme_vars.ajaxurl, requestOptions)
    .then((response) => response.json())
    .then((data) => {
      const postHTML = data.data.post_html;
      const hasMorePosts = data.data.has_more_posts && (loadMoreButton.dataset.paged <= dataset.max_num_pages);

      if(hasMorePosts) {
        document.querySelector('.articles-inner').insertAdjacentHTML('beforeend', postHTML);
        loadMoreButton.textContent = 'Load more...';
        loadMoreButton.style.pointerEvents = "auto";

        if(dataset.paged >= dataset.max_num_pages) {
          loadMoreButton.style.display = 'none';
        }
        else {
          loadMoreButton.dataset.paged = parseInt(parseInt(dataset.paged) + 1);
        }
      }
      else {
        loadMoreButton.insertAdjacentHTML('afterend', postHTML);
        loadMoreButton.style.display = 'none';
      }
    })
    .catch(console.error);
    
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.getElementById('loadMorePosts').addEventListener('click', (e) => {
      e.preventDefault();
      e.currentTarget.style.pointerEvents = "none";
      e.currentTarget.textContent = 'Please wait...';
      getMorePosts(e.currentTarget.dataset);
    });
  });

}


// WEBPACK FOOTER //
// ./assets/js/modules/load-more.js